module.exports = __webpack_public_path__ + "static/media/bussiness_character.f73f7d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bussiness_character.png
// module id = 376
// module chunks = 21